export const REGISTER_TASK = 'register_task';
export const REGISTER_TASK_SUCCESSFUL = 'register_task_successfull';
export const REGISTER_TASK_FAILED = 'register_task_failed';



